import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import createPlotlyComponent from 'react-plotly.js/factory'
import Plotly from 'plotly.js-basic-dist-min'

const Plot = createPlotlyComponent(Plotly)

const eurFormatter = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' })

const CURRENT_COLOR = '#0b8043'
const PREVIOUS_COLOR = '#a5d6b3'

const PRODUCT_TYPE_LABELS = {
  reservation: 'Kenttävaraus',
  extra: 'Lisätuote',
  product: 'Proshop',
  ticket: 'Lippu',
  membership: 'Jäsenyys',
  benefitcard: 'Sarjakortti',
  saldotopup: 'Saldolataus',
  other: 'Muu',
}

const ProductTypeSalesCard = ({ title = 'Myynti tuotetyypeittäin', data, loading, currentLabel = 'Tämä viikko', previousLabel = 'Viime viikko' }) => {
  const safe = Array.isArray(data) ? data : []
  const xs = safe.map((d) => (PRODUCT_TYPE_LABELS[d.type] || d.type || '—').toLocaleUpperCase('fi-FI'))
  const yCurrent = safe.map((d) => Number(d.current) || 0)
  const yPrevious = safe.map((d) => Number(d.previous) || 0)

  const traces = [
    {
      x: xs,
      y: yPrevious,
      name: previousLabel,
      type: 'bar',
      marker: { color: PREVIOUS_COLOR },
      hovertemplate: `%{x}: %{y:,.2f} €<extra>${previousLabel}</extra>`,
    },
    {
      x: xs,
      y: yCurrent,
      name: currentLabel,
      type: 'bar',
      marker: { color: CURRENT_COLOR },
      hovertemplate: `%{x}: %{y:,.2f} €<extra>${currentLabel}</extra>`,
    },
  ]

  const layout = {
    autosize: true,
    height: 240,
    margin: { l: 50, r: 12, t: 4, b: 60 },
    barmode: 'group',
    showlegend: true,
    legend: { orientation: 'h', x: 0, y: 1.15, font: { size: 11 } },
    xaxis: { tickangle: -25, automargin: true, tickfont: { size: 11, color: '#5f6368' } },
    yaxis: { tickfont: { size: 11, color: '#5f6368' }, gridcolor: 'rgba(0,0,0,0.06)', tickformat: ',.0f' },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    separators: ', ',
    hoverlabel: { bgcolor: '#fff' },
  }

  const config = { displayModeBar: false, responsive: true }

  const total = safe.reduce((acc, d) => acc + (Number(d.current) || 0), 0)

  return (
    <Card sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent sx={{ p: '12px 14px', '&:last-child': { pb: '12px' } }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
          <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>
            {title}
          </Typography>
          {!loading && safe.length > 0 && (
            <Typography variant='caption' sx={{ color: 'text.secondary' }}>
              Yhteensä {eurFormatter.format(total)}
            </Typography>
          )}
        </Box>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 240 }}>
            <CircularProgress size={20} />
          </Box>
        ) : safe.length === 0 ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 240, color: 'text.secondary', fontSize: 12, textAlign: 'center', px: 2 }}>
            Tuotetyyppikohtainen erittely vaatii backend-päivityksen.<br />Tieto ilmestyy heti, kun palvelin lähettää sen.
          </Box>
        ) : (
          <Plot data={traces} layout={layout} config={config} style={{ width: '100%', height: 240 }} useResizeHandler />
        )}
      </CardContent>
    </Card>
  )
}

export default ProductTypeSalesCard
